import React from 'react';
import MainPanel from '../../components/layout/MainPanel';
import { useDashboardData } from '../../components/DashboardShell';
import { useLocale } from '../../context/LocaleContext';
import Analytics from '../Analytics';

export default function ReportsConversations() {
  const { data } = useDashboardData();
  const { t } = useLocale();
  const profile = data?.profile;
  return (
    <MainPanel
      variant="reports"
      title={t('reports.conversationsTitle')}
      subtitle={
        profile?.displayName
          ? t('reports.conversationsSubtitleNamed', { name: profile.displayName })
          : t('reports.conversationsSubtitle')
      }
    >
      <Analytics />
    </MainPanel>
  );
}
